import withReducer from '../../store/withReducer'
import PatientEkgRecording from './container'
import reducer from './module'

export default withReducer('patientEkgRecording', reducer)(PatientEkgRecording)



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientEkgRecording/index.js